import {HingeSideService} from "./hingeSideService";

export class DoorDrawingService
{
    private width: number = 0;
    private hingeSide: number = HingeSideService.LEFT_HINGE_ID;
    private height: number = 0;
    private inside: any = {
        colorHex: <string> null,
        image: <string> null,
    };
    private outside: any = {
        colorHex: <string> null,
        image: <string> null,
    };

    constructor()
    {
    }

    public setHingeSide(hingeSide: number)
    {
        this.hingeSide = hingeSide;
    }

    public setWidth(width: number)
    {
        this.width = width;
    }

    public setHeight(height: number)
    {
        this.height = height;
    }

    public setColorHex(side: string, colorHex: string)
    {
        this[side].colorHex = colorHex;
    }

    public setImage(side: string, image: number)
    {
        this[side].image = image;
    }

    public update(viewSide: string)
    {
        this.updateViewBox(viewSide);
        this.updateColorNode(viewSide);
        this.updatePanelNode(viewSide);
        this.updateBottomDimensionNode(viewSide);
        this.updateSideDimensionNode(viewSide);
    }

    private updateSideDimensionNode(viewSide: string)
    {
        const SideDimension = document.querySelector('.icc-draw .SideDimension');
        const SideDimensionLeftRuler = SideDimension.querySelector('.leftRulerEdge');
        const SideDimensionRightRuler = SideDimension.querySelector('.rightRulerEdge');
        const SideDimensionMiddleRuler = SideDimension.querySelector('.middleRulerEdge');
        const SideDimensionTopText = SideDimension.querySelector('.topMeasurement');
        const SideDimensionBottomText = SideDimension.querySelector('.bottomMeasurement');
        
        const middleSidePathDefinition = this.calculateMiddleLinePathDefinition('side', viewSide);
        const rightSidePathDefinition = this.calculateRightEdgePathDefinition('side', viewSide);
        const leftSidePathDefinition = this.calculateLeftEdgePathDefinition('side', viewSide);

        SideDimensionMiddleRuler.setAttribute('d', `
            M 
            ${middleSidePathDefinition[0][0]} 
            ${middleSidePathDefinition[0][1]} 
            L 
            ${middleSidePathDefinition[1][0]} 
            ${middleSidePathDefinition[1][1]}`
        );
        SideDimensionRightRuler.setAttribute('d', `
            M 
            ${rightSidePathDefinition[0][0]} 
            ${rightSidePathDefinition[0][1]} 
            L 
            ${rightSidePathDefinition[1][0]} 
            ${rightSidePathDefinition[1][1]}`
        );
        SideDimensionLeftRuler.setAttribute('d', `
            M 
            ${leftSidePathDefinition[0][0]} 
            ${leftSidePathDefinition[0][1]} 
            L 
            ${leftSidePathDefinition[1][0]} 
            ${leftSidePathDefinition[1][1]}`
        );

        var bottomTextX = `${this.width + 180}`;
        var topTextX = `${this.width + 60}`;

        if (viewSide === 'outside') {
            bottomTextX = `-${bottomTextX}`;
            topTextX = `-${topTextX}`;
        }
        SideDimensionTopText.setAttribute('y', `${this.height / 2}`);
        SideDimensionTopText.setAttribute('x', topTextX);
        SideDimensionTopText.setAttribute('transform', `rotate(
            270,
            ${topTextX},
            ${this.height / 2}
        )`);
        SideDimensionTopText.textContent = this.height.toString();

        SideDimensionBottomText.setAttribute('y', `${this.height / 2}`);
        SideDimensionBottomText.setAttribute('x', bottomTextX);
        SideDimensionBottomText.setAttribute('transform', `rotate(
            270,
            ${bottomTextX},
            ${this.height / 2}
        )`);
        SideDimensionBottomText.textContent = this.height.toString();
    }

    private updateBottomDimensionNode(viewSide: string)
    {
        const BottomDimension = document.querySelector('.icc-draw .BottomDimension');
        const BottomDimensionLeftRuler = BottomDimension.querySelector('.leftRulerEdge');
        const BottomDimensionRightRuler = BottomDimension.querySelector('.rightRulerEdge');
        const BottomDimensionMiddleRuler = BottomDimension.querySelector('.middleRulerEdge');
        const BottomDimensionTopText = BottomDimension.querySelector('.topMeasurement');
        const BottomDimensionBottomText = BottomDimension.querySelector('.bottomMeasurement');

        const middlePathDefinition = this.calculateMiddleLinePathDefinition('bottom', viewSide);
        const rightPathDefinition = this.calculateRightEdgePathDefinition('bottom', viewSide);
        const leftPathDefinition = this.calculateLeftEdgePathDefinition('bottom', viewSide);

        BottomDimensionMiddleRuler.setAttribute('d', `
            M 
            ${middlePathDefinition[0][0]} 
            ${middlePathDefinition[0][1]} 
            L 
            ${middlePathDefinition[1][0]} 
            ${middlePathDefinition[1][1]}`
        );
        BottomDimensionRightRuler.setAttribute('d', `
            M 
            ${rightPathDefinition[0][0]} 
            ${rightPathDefinition[0][1]} 
            L 
            ${rightPathDefinition[1][0]} 
            ${rightPathDefinition[1][1]}`
        );
        BottomDimensionLeftRuler.setAttribute('d', `
            M 
            ${leftPathDefinition[0][0]} 
            ${leftPathDefinition[0][1]} 
            L 
            ${leftPathDefinition[1][0]} 
            ${leftPathDefinition[1][1]}`
        );
        var bottomDimensionTextX = `${this.width / 2}`;

        if (viewSide === 'outside') {
            bottomDimensionTextX = `-${bottomDimensionTextX}`;
        }
        BottomDimensionTopText.setAttribute('x', bottomDimensionTextX.toString());
        BottomDimensionTopText.setAttribute('y', `${this.height + 60}`);

        BottomDimensionBottomText.setAttribute('x', bottomDimensionTextX.toString());
        BottomDimensionBottomText.setAttribute('y', `${this.height + 180}`);

        BottomDimensionTopText.textContent = this.width.toString();
        BottomDimensionBottomText.textContent = this.width.toString();
    }

    private updatePanelNode(viewSide: string)
    {
        const panelNode = document.querySelector('.icc-draw .DoorModel image');

        if (viewSide === 'inside') {
            panelNode.setAttribute('x', '0');
        } else {
            panelNode.setAttribute('x', '-' + this.width);

            if (this.hingeSide === HingeSideService.LEFT_HINGE_ID) {
                panelNode.setAttribute('transform', `translate(
                    -${this.width},
                    0
                ) scale(
                    -1,
                    1
                )`);
            }
            if (this.hingeSide === HingeSideService.RIGHT_HINGE_ID) {
                panelNode.setAttribute('transform', `translate(
                    ${this.width},
                    0
                ) scale(
                    1,
                    -1
                ); transform-origin: center;`);
            }
        }
        panelNode.setAttribute('y', '0');
        panelNode.setAttribute('width', this.width.toString());
        panelNode.setAttribute('height', this.height.toString());
        panelNode.setAttribute('xlink:href', this[viewSide].image);
    }

    private updateColorNode(viewSide)
    {
        const colorNode = document.querySelector('.icc-draw .DoorColor rect');
        colorNode.setAttribute('x', (viewSide === 'inside') ? '0' : `-${this.width}`);
        colorNode.setAttribute('y', '0');
        colorNode.setAttribute('width', this.width.toString());
        colorNode.setAttribute('height', this.height.toString());
        colorNode.setAttribute('style', `fill: ${this[viewSide].colorHex};`);
    }

    private updateViewBox(viewSide: string)
    {
        const mainElement = document.querySelector('.icc-door-draw');
        const viewBox = this.calculateViewBox(viewSide);
        mainElement.setAttribute('viewBox', `
            ${viewBox[0]}
            ${viewBox[1]}
            ${viewBox[2]}
            ${viewBox[3]}
        `);
    }

    private calculateViewBox(viewSide: string = 'inside')
    {
        var position = [];

        if (viewSide === 'inside') {
            position.push(0);
            position.push(0);
        } else {
            position.push(-(this.width + 180));
            position.push(0);
        }
        position.push(this.width + 180);
        position.push(this.height + 180);

        return position;
    }

    private calculateMiddleLinePathDefinition(direction: string = 'bottom', viewSide: string = 'inside')
    {
        var moveTo = [];
        var lineTo = [];

        if (direction === 'bottom') {
            moveTo.push(0);
            moveTo.push(this.height + 120);

            if (viewSide === 'inside') {
                lineTo.push(this.width);
            } else {
                lineTo.push(-this.width);
            }
            lineTo.push(this.height + 120);
        } else {
            if (viewSide === 'inside') {
                moveTo.push(this.width + 120);
                moveTo.push(0);

                lineTo.push(this.width + 120);
            } else {
                moveTo.push(-(this.width + 120));
                moveTo.push(0);

                lineTo.push(-(this.width + 120));
            }
            lineTo.push(this.height);
        }
        return [
            moveTo,
            lineTo,
        ];
    }

    private calculateRightEdgePathDefinition(direction: string = 'bottom', viewSide: string = 'inside')
    {
        var moveTo = [];
        var lineTo = [];

        if (direction === 'bottom') {
            moveTo.push(0);
            moveTo.push(this.height + 60);

            if (viewSide === 'inside') {
                lineTo.push(0);
                lineTo.push(this.height + 180);
            } else {
                lineTo.push(0);
                lineTo.push(this.height + 180);
            }
        } else {
            if (viewSide === 'inside') {
                moveTo.push(this.width + 60);
                moveTo.push(0);

                lineTo.push(this.width + 180);
                lineTo.push(0);
            } else {
                moveTo.push(-(this.width + 60));
                moveTo.push(0);

                lineTo.push(-(this.width + 180));
                lineTo.push(0);
            }
        }
        return [
            moveTo,
            lineTo,
        ];
    }

    private calculateLeftEdgePathDefinition(direction: string = 'bottom', viewSide: string = 'inside')
    {
        var moveTo = [];
        var lineTo = [];

        if (direction === 'bottom') {
            if (viewSide === 'inside') {
                moveTo.push(this.width);
                moveTo.push(this.height + 60);

                lineTo.push(this.width);
            } else {
                moveTo.push(-this.width);
                moveTo.push(this.height + 60);

                lineTo.push(-this.width);
            }
            lineTo.push(this.height + 180);
        } else {
            if (viewSide === 'inside') {
                moveTo.push(this.width + 60);
                moveTo.push(this.height);

                lineTo.push(this.width + 180);
            } else {
                moveTo.push(-(this.width + 60));
                moveTo.push(this.height);

                lineTo.push(-(this.width + 180));
            }
            lineTo.push(this.height);
        }
        return [
            moveTo,
            lineTo,
        ];
    }
}
